{
  "#APP_OVERVIEW": {
    "ALL_APPLICATIONS": "Alle Applikationen",
    "MY_APPLICATIONS": "Meine Applikationen",
    "FAVORITES": "Favoriten",
    "SEARCH": "Alle Applikationen durchsuchen...",
    "GRID": "Rasteransicht",
    "LIST": "Listenansicht"
  }
}
